import { render, staticRenderFns } from "./SuppliersTable.vue?vue&type=template&id=c1a06ad2&scoped=true&lang=pug"
import script from "./SuppliersTable.vue?vue&type=script&lang=js"
export * from "./SuppliersTable.vue?vue&type=script&lang=js"
import style0 from "./SuppliersTable.vue?vue&type=style&index=0&id=c1a06ad2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a06ad2",
  null
  
)

export default component.exports